import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";
import { parseLangPath, isPublicPath, pathFor } from "../lib/i18nRoutes";

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const buttonRef = useRef(null);

  const languages = [
    { code: "pt", name: "Português", flag: "🇧🇷" },
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "es", name: "Español", flag: "🇪🇸" },
  ];

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 8,
        right: window.innerWidth - rect.right,
      });
    }
  }, [isOpen]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    setIsOpen(false);
    // Em página pública, troca a URL para a versão do idioma (o canonical/hreflang
    // e o LanguageSync acompanham). Fora das públicas, só muda o idioma.
    const { basePath } = parseLangPath(location.pathname);
    if (isPublicPath(basePath)) {
      navigate(pathFor(lng, basePath));
    }
  };

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ${isOpen ? "bg-slate-200 text-slate-600" : "text-slate-400 hover:text-slate-600 hover:bg-slate-100"}`}
        title={t("common.selectLanguage")}
      >
        <FaGlobe className="w-[18px] h-[18px]" />
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[60]"
            onClick={() => setIsOpen(false)}
          />
          <div
            className="fixed w-44 bg-white rounded-xl shadow-lg py-2 z-[70] border border-slate-100"
            style={{
              top: dropdownPosition.top,
              right: dropdownPosition.right,
            }}
          >
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 transition-colors ${
                  i18n.language === lang.code
                    ? "bg-slate-50 text-slate-800 font-medium"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <span className="text-base">{lang.flag}</span>
                <span>{lang.name}</span>
                {i18n.language === lang.code && (
                  <span className="ml-auto text-slate-400">✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
